import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import styled from 'styled-components';
import {currentTheme} from '../../react-themes/theme';
import {t} from '../../shared-services/translate';
import {RjsProductList} from '../RjsProductList';
import {useSelector} from '../../shared-services/redux-tiny';
import * as _ from 'underscore';
import {trackEvent} from '../../services/tracking-helper';

const theme = currentTheme();
const searchFormSuggestionHeight = '40px';
const searchFormSuggestionHeightMobile = '38px';
const searchFormSuggestionWidth = '45px';
const dropDownPadding = 21 + 55;
const maxContainerHeight = 552;

function fixContainerHeight() {
  let containerHeight;
  if (NgFrontendAppCtrl.ngfrontend.isMobile) {
    containerHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - $('.search-form-suggestions-panel').offset().top - $('body')[0].scrollTop - 20;
    $('.search-form-suggestions-panel').css('height', containerHeight);
    $('.search-form-suggestions-panel').css('margin-bottom', -containerHeight);
  } else {
    let actualHeight = _.max(_.map($('.search-form-suggestions-panel .search-dropdown .search-dropdown-content'), function(el) { return parseInt($(el).css('height')) }));
    if (actualHeight > dropDownPadding) {
      containerHeight = _.min([actualHeight + dropDownPadding, maxContainerHeight]);

      $('.search-form-suggestions-panel').css('height', containerHeight);
      $('.search-form-suggestions-panel').css('margin-bottom', -containerHeight);
    }
  }
}

export const useOutsideClickRef = (onOutsideClick = () => {}, identifier) => {
  const currentSearch = useSelector(state => state.session.currentSearch);
  const selfRef = useRef();

  const checkOutsideClick = (event) => {
    const excludedElements = event.target?.classList.contains('search-component');
    if (event.target && !excludedElements && selfRef.current && !selfRef.current.contains(event.target)) {
      onOutsideClick();
    }
  };

  useLayoutEffect(() => {
    if (currentSearch?.isOpen && currentSearch?.origin === identifier && identifier !== 'header-mobile') {
      document.addEventListener('mousedown', checkOutsideClick);
    } else {
      document.removeEventListener('mousedown', checkOutsideClick);
    }
    return () => document.removeEventListener('mousedown', checkOutsideClick);
  }, [currentSearch]);

  return selfRef;
};

const SearchDropdown = ({identifier}) => {
  const currentSearch = useSelector(state => state.session.currentSearch);
  const [isOpen, setIsOpen] = useState(false);
  let fixContainerHeightTimeout = null;

  const closeSearch = (e, gtmIdentifier) => {
    if (gtmIdentifier) {
      trackEvent('search',
        {
          gtmObject: {
            type: 'suggested',
            searchterm: currentSearch?.keywords,
            selection: gtmIdentifier
          }
        });
    }
    identifier === 'header-mobile' ? window.farmyMobileSidebar.hideSidebarAndCloseSearch() : window.NavRichSearchCtrl.collapse();
    setIsOpen(false);
  };

  const outsideClickRef = useOutsideClickRef(closeSearch, identifier);

  useEffect(() => {
    const isOpenState = currentSearch?.productSuggestions &&
      currentSearch?.isOpen &&
      currentSearch?.origin === identifier;
    setIsOpen(isOpenState);
  }, [currentSearch]);


  useEffect(() => {
    if (isOpen && window.isMobile) {
      if (fixContainerHeightTimeout) clearTimeout(fixContainerHeightTimeout);

      fixContainerHeightTimeout = setTimeout(function() {
        fixContainerHeight();
      }, 100);
    }
  }, [currentSearch, isOpen]);

  useEffect(() => {
    if (currentSearch && currentSearch.keywords) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [currentSearch]);

  const highlightText = (text, highlight) => {
    const wordParts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span>{wordParts.map((part, i) => <span key={i} className={part.toLowerCase() === highlight ? 'highlight' : ''}>{part}</span>)}</span>;
  };

  return <StyledSearchDropdown className={`search-form-suggestions-panel full-width ${isOpen ? 'flex align-items-center justify-content-center' : 'display-none'}`} isOpen={isOpen} layout={identifier} productsNumber={currentSearch?.productSuggestions?.length} ref={outsideClickRef}>
    <div className={`search-dropdown ${identifier === 'header-desktop' ? 'container container-fluidish col-xs-12' : ''}`}>
      <div className='search-dropdown-content'>
        {window.isMobile && currentSearch?.taxonSuggestions?.length > 0 && <div className="col-xs-12">
          <div className='search-form-suggestions-group search-form-suggestions-group-taxons'>
            <div className='search-form-suggestions'>
              {currentSearch?.taxonSuggestions?.length > 0 && currentSearch.taxonSuggestions.map(taxon => {
                return (
                  <div key={taxon.id} className='search-form-suggestion mobile-taxon-suggestion'>
                    <a href={taxon.url} className='name' onClick={() => closeSearch(null, 'category')}>{taxon.name}</a>
                  </div>);
              })}
            </div>
          </div>
        </div>}
        {currentSearch?.productSuggestions?.length > 0 && <div className='col-xs-12 col-sm-6'>
          <div className='search-form-suggestions-group search-form-suggestions-group-products' data-analytics-list-name='Search Form Suggestions'>
            {!window.isMobile &&
              <div className='group-name'>
                {t('spree.products')}
              </div>}
            <div className='search-form-suggestions'>
              <RjsProductList
                products={currentSearch?.productSuggestions}
                layout={'search'}
                hideMoreButton={true}
                trackingListName={`search_suggestions${currentSearch?.keywords ? "#" + currentSearch.keywords : ""}`}
                keywords={currentSearch?.keywords}
                parentNodeId={`search-dropdown-${identifier}`}
                callerLocation={"search"}
              />
            </div>
            <a onClick={e => closeSearch(e, 'show more')} href={`/${window.I18n.locale !== 'de' ? window.I18n.locale + '/' : ''}products?keywords=${currentSearch.keywords}`} className='show-more'>
              {t('spree.search_form.show_more_results')}
            </a>
          </div>
        </div>}
        <div className='col-xs-12 col-sm-6 non-product-results'>
          {(currentSearch?.supplierSuggestions?.length > 0 || (!window.isMobile && currentSearch?.taxonSuggestions?.length > 0)) &&
            <div className='non-keywords-results'>
              {!window.currentStorefront && currentSearch?.supplierSuggestions?.length > 0 &&
              <div className='search-form-suggestions-group search-form-suggestions-group-suppliers'>
                <div className='group-name'>
                  {t('producers')}
                </div>
                <div className='search-form-suggestions'>
                  {currentSearch?.supplierSuggestions?.length > 0 && currentSearch.supplierSuggestions.map(supplier => {
                    return (
                      <div key={supplier.name} className='search-form-suggestion'>
                        <img src={supplier.mini_image_url} className='thumb'/>
                        <a href={supplier.url} className='name' onClick={() => closeSearch(null, 'producers')}>{supplier.name}</a>
                      </div>);
                  })}
                </div>
              </div>}
              {!window.isMobile && currentSearch?.taxonSuggestions?.length > 0 &&
              <div className='search-form-suggestions-group search-form-suggestions-group-taxons'>
                <div className='group-name'>
                  {t('filters.category')}
                </div>
                <div className='search-form-suggestions'>
                  {currentSearch?.taxonSuggestions?.length > 0 && currentSearch.taxonSuggestions.map(taxon => {
                    return (
                      <div key={taxon.id} className='search-form-suggestion'>
                        <img src={taxon.mini_image_url} className='thumb'/>
                        <a href={taxon.url} className='name' onClick={() => closeSearch(null, 'category')}>{taxon.name}</a>
                      </div>);
                  })}
                </div>
              </div>}
            </div>}
          {currentSearch?.keywordSuggestions?.length > 0 && <div className='search-form-suggestions-group search-form-suggestions-group-searches'>
            <div className='group-name'>
              {t('spree.search_form.popular_searches')}
            </div>
            {currentSearch?.keywordSuggestions?.map((suggestion, i) => {
              return (
                <span key={i} className='search-form-suggestion-word'>
                  <a className='name' href={`/${window.I18n.locale !== 'de' ? window.I18n.locale + '/' : ''}products?keywords=${suggestion}`} onClick={() => closeSearch(null, 'search for these products?')}>{highlightText(suggestion, currentSearch?.keywords)}</a>
                  {(currentSearch?.keywordSuggestions?.length - 1) !== i && <span className='sep'>, </span>}
                </span>);
            })}
          </div>}
        </div>
      </div>
    </div>
  </StyledSearchDropdown>;
};

export default SearchDropdown;

const StyledSearchDropdown = styled.div`
  // Embeddable search form with rich-media suggestions
  &.search-form-suggestions-panel {
    max-height: ${maxContainerHeight}px;
    background: white;
    margin-top: 0px;
    z-index: ${props => props.layout === 'jumbo' ? 2000 : 4200};
    position: absolute;
    box-shadow: ${props => props.layout === 'jumbo' ? '1px 15px 15px rgba(0,0,0,.1)' : 'inset 0 7px 9px -7px rgba(0,0,0,0.2)'};
    border-bottom-right-radius: ${props => props.layout === 'header-mobile' ? '2px' : props.layout === 'jumbo' ? '3px' : '0px'};
    border-bottom-left-radius: ${props => props.layout === 'header-mobile' ? '2px' : props.layout === 'jumbo' ? '3px' : '0px'};
    transition: all .2s ease-out;
    opacity: 1;
  }
  &.ng-hide {
    opacity: 0;
  }
  .search-dropdown {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-height: ${maxContainerHeight}px;
    padding-top: 21px;
    line-height: 1.1;
    overflow: auto;
    width: ${props => props.layout === 'header-desktop' ? '100%' : '100%'};
    height: 100%;
    .search-dropdown-content {
      display: flex;
      flex-direction: ${props => props.layout === 'header-mobile' ? 'column' : 'row'};
      gap: ${props => props.layout === 'header-mobile' ? '40px' : '65px'};
      padding-left: ${props => props.layout === 'header-desktop' ? '84px' : '0px'};
      .search-form-suggestions-group-products {
        display: flex;
        flex-direction: column;
        padding-bottom: ${props => props.layout === 'header-mobile' ? '0px' : '55px'};
        a.show-more {
          color: ${theme.colors.farmy.orange};
          text-decoration: underline;
          align-self: ${props => props.layout === 'header-mobile' ? 'center' : 'flex-start'};
          &:hover {
            color: ${theme.colors.primaryColor};
          }
        }
      }
    }
  }
  // Suggesstions
  .search-form-suggestions-group {
    .group-name {
      color: ${theme.colors.farmy.grey};
      font-size: ${props => props.layout === 'header-mobile' ? '16px' : '20px'};
      margin-bottom: 19px;
      font-weight: 600;
    }
    a.name {
      color: ${theme.colors.farmy.grey};
      font-size: ${props => props.layout === 'header-mobile' ? '14px' : '16px'};
      &:hover {
        color: ${theme.colors.primaryColor};
      }
    }
  }

  .search-form-suggestion {
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    
    &:first-of-type {
      padding-top: 0;
    }
    &:last-child {
      border-bottom: ${props => props.layout === 'header-mobile' ? '1px solid #eee' : 'none'};
      padding-bottom: ${props => props.layout === 'header-mobile' ? '10px' : '0'};
    }
    .thumb {
      width: ${searchFormSuggestionWidth};
      height: ${props => props.layout === 'header-mobile' ? searchFormSuggestionHeightMobile : searchFormSuggestionHeight};
      margin-right: 4px;
      border-radius: 4px;
    }
    
    &.mobile-taxon-suggestion {
      border-bottom: none;
    }
  }

  .non-product-results {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: ${props => props.layout === 'header-mobile' ? 'auto' : '100%'};
    .search-form-suggestions-group-searches {
      margin: ${props => props.layout === 'header-mobile' ? '0px 0px 40px 0px' : props.productsNumber < 3 ? '40px 0px 55px 0px' : '40px 0px 114px 0px'};
      .search-form-suggestion-word {
        color: ${theme.colors.farmy.grey};
        &:hover {
          a.name, a.name span{
            color: ${theme.colors.primaryColor};
          }
        }
        a.name span{
          color: ${theme.colors.farmy.grey};
        }
      }
    }
  }
  .non-keywords-results {
    display: flex;
    flex-direction: ${props => props.layout === 'header-mobile' ? 'column' : 'row'};
    width: 100%;
    gap: ${props => props.layout === 'header-mobile' ? '40px' : '85px'};
    margin-bottom: ${props => props.layout === 'header-mobile' ? '40px' : '0'};
    .search-form-suggestions-group {
      width: 50%;
      .thumb {
        margin-right: 15px;
      }
    }
  }
  .highlight {
    text-decoration: underline;
  }
`;
